export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  imageSeq: string;
  imageQuery: string;
  readTime: number;
  publishedAt: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'a001',
    title: '如何打造一个让人不想出门的家？5个品质家居灵感',
    slug: 'how-to-create-a-home-you-never-want-to-leave',
    excerpt: '家是心灵的港湾，一个精心布置的家能让每一天都充满幸福感。本文分享5个来自全球设计师的品质家居灵感，让你的家成为最舒适的避风港。',
    content: `<p>在快节奏的现代生活中，家不仅是一个居住空间，更是我们放松身心、重新充电的港湾。一个真正让人不想出门的家，不在于面积大小，而在于每一个细节的用心。</p>
    <h2>1. 选择经得起时间考验的家具</h2>
    <p>真正的好家具，是能够陪伴你十年甚至更久的。选择实木、真皮等天然材质制作的家具，它们会随着时间推移愈发散发独特的韵味。比如一张北欧白橡木餐桌，不仅坚固耐用，木纹还会随着岁月变得更加温润。</p>
    <h2>2. 用灯光营造氛围层次</h2>
    <p>灯光是家居氛围的灵魂。告别单一的顶灯，尝试在房间不同角落布置落地灯、台灯和壁灯。一盏手工陶瓷香薰灯，既能提供柔和光线，又能散发宜人香气，一物多用。</p>
    <h2>3. 引入自然元素</h2>
    <p>绿植、鲜花、木质元素，这些自然之物能为空间注入生命力。哪怕只是窗台上的一盆绿萝，或是茶几上的一束干花，都能让家更有人情味。</p>
    <h2>4. 注重触感体验</h2>
    <p>真丝枕套、羊绒毯子、有机棉家居服……这些与肌肤亲密接触的物品，最值得投资。好的材质带来的舒适感，是任何装饰都无法替代的。</p>
    <h2>5. 打造属于自己的角落</h2>
    <p>无论是阅读角、茶席还是瑜伽区，在家中开辟一个专属于自己的小天地。放上一把舒适的椅子、一盏温暖的灯，这就是你逃离喧嚣的秘密基地。</p>
    <p>品质生活，始于每一个用心的选择。久久精品，为你甄选每一件经得起时间考验的好物。</p>`,
    category: '家居好物',
    author: '久久编辑部',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautifully%20styled%20cozy%20living%20room%20with%20warm%20lighting%2C%20wooden%20furniture%2C%20indoor%20plants%2C%20soft%20textiles%2C%20and%20bookshelves%2C%20creating%20an%20inviting%20atmosphere%2C%20interior%20design%20magazine%20quality%20photography&width=1200&height=600&seq=article-a001&orientation=landscape',
    imageWidth: 1200,
    imageHeight: 600,
    imageSeq: 'article-a001',
    imageQuery: 'A beautifully styled cozy living room with warm lighting, wooden furniture, indoor plants, soft textiles, and bookshelves, creating an inviting atmosphere, interior design magazine quality photography',
    readTime: 6,
    publishedAt: '2026-08-01',
    tags: ['家居', '设计', '生活品质', '室内装饰'],
  },
  {
    id: 'a002',
    title: '2026秋冬时尚趋势：经典永不过时的5件单品',
    slug: '2026-autumn-winter-fashion-trends-timeless-pieces',
    excerpt: '时尚潮流瞬息万变，但真正的好品味从不盲从。我们为你梳理了5件经得起时间考验的经典单品，让你在每个季节都优雅从容。',
    content: `<p>真正的时尚不是追逐潮流，而是找到属于自己的风格。本季秋冬，我们更关注那些能够陪伴你多年的经典单品。它们或许不够张扬，但每一件都值得拥有。</p>
    <h2>1. 一件剪裁精良的羊绒大衣</h2>
    <p>投资一件好羊绒大衣，是对自己最好的犒赏。选择经典的驼色或燕麦色，它可以陪你度过无数个秋冬，越穿越有味道。</p>
    <h2>2. 一条百搭的羊绒围巾</h2>
    <p>一条柔软的羊绒混纺围巾，不仅保暖，更是整体造型的点睛之笔。披在肩上即是优雅的披肩，围在颈间则是温暖的呵护。</p>
    <h2>3. 一只经典款真皮手袋</h2>
    <p>意大利手工牛皮托特包，简约的线条、上乘的皮质，不需要任何Logo装饰，考究的工艺本身就足够说明一切。</p>
    <h2>4. 一条精致的锁骨链</h2>
    <p>日式极简纯银锁骨链，小巧的吊坠在颈间若隐若现，低调中见精致。日常佩戴不张扬，却能让整体气质提升一个层次。</p>
    <h2>5. 一双舒适的经典鞋履</h2>
    <p>舒适的鞋履是好心情的基础。选择经典款式与优质皮料，你会发现它们比任何潮流款都更值得拥有。</p>
    <p>久久精品相信，真正的好物，是那些能陪你走过漫长岁月的伙伴。</p>`,
    category: '时尚精品',
    author: '久久编辑部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20autumn%20winter%20fashion%20editorial%20with%20classic%20pieces%2C%20cashmere%20coat%2C%20leather%20bag%2C%20and%20wool%20scarf%20displayed%20artistically%2C%20warm%20golden%20hour%20lighting%2C%20luxury%20fashion%20magazine%20style&width=1200&height=600&seq=article-a002&orientation=landscape',
    imageWidth: 1200,
    imageHeight: 600,
    imageSeq: 'article-a002',
    imageQuery: 'Elegant autumn winter fashion editorial with classic pieces, cashmere coat, leather bag, and wool scarf displayed artistically, warm golden hour lighting, luxury fashion magazine style',
    readTime: 5,
    publishedAt: '2026-07-25',
    tags: ['时尚', '秋冬', '经典单品', '穿搭'],
  },
  {
    id: 'a003',
    title: '慢生活哲学：在快节奏时代找回生活的质感',
    slug: 'slow-living-philosophy-finding-quality-in-fast-times',
    excerpt: '在这个一切都在加速的时代，我们更需要学会慢下来。本文与你分享慢生活哲学，从日常小物开始，重新感受生活的质感与温度。',
    content: `<p>我们生活在一个追求效率的时代，快递要次日达、信息要即时回、连吃饭都要争分夺秒。但在久久精品看来，真正有品质的生活，恰恰需要慢下来。</p>
    <h2>慢，是一种选择</h2>
    <p>慢生活不是懒散，而是一种主动的选择。选择在清晨用铸铁茶壶煮一壶好茶，而不是匆忙灌下一杯速溶咖啡。选择在睡前点燃一盏香薰蜡烛，而不是刷着手机入睡。这些看似微小的选择，构成了我们的生活品质。</p>
    <h2>从日常物品中感受时间</h2>
    <p>机器批量生产的东西，快则快矣，却少了灵魂。而一件手工陶瓷、一只黄铜书签、一把铸铁茶壶，它们的价值恰恰在于制作过程中倾注的时间与心意。使用这样的物品，本身就是一种慢生活的实践。</p>
    <h2>少即是多的生活美学</h2>
    <p>我们不需要堆满屋子的物品，而是需要那些真正被使用、被珍视的好物。少买，但买好的。这不仅是对自己生活品质的投资，也是对地球资源的尊重。</p>
    <h2>在日常中建立仪式感</h2>
    <p>仪式感不需要轰轰烈烈。晨起一杯温水、午后一段阅读时光、睡前十分钟的瑜伽拉伸——这些日常中的小仪式，让普通的一天也变得特别。</p>
    <p>久久精品与你一起，在快节奏的世界里，找到属于自己的慢生活节奏。</p>`,
    category: '生活优选',
    author: '久久编辑部',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20peaceful%20morning%20ritual%20scene%20with%20a%20cast%20iron%20teapot%2C%20steaming%20tea%2C%20an%20open%20book%2C%20and%20soft%20sunlight%20on%20a%20wooden%20table%2C%20minimalist%20zen%20Japanese%20aesthetic%2C%20calm%20and%20serene%20atmosphere&width=1200&height=600&seq=article-a003&orientation=landscape',
    imageWidth: 1200,
    imageHeight: 600,
    imageSeq: 'article-a003',
    imageQuery: 'A peaceful morning ritual scene with a cast iron teapot, steaming tea, an open book, and soft sunlight on a wooden table, minimalist zen Japanese aesthetic, calm and serene atmosphere',
    readTime: 7,
    publishedAt: '2026-07-18',
    tags: ['慢生活', '生活哲学', '品质生活', '仪式感'],
  },
  {
    id: 'a004',
    title: '送礼的艺术：如何挑选一份让人心动的礼物？',
    slug: 'the-art-of-gift-giving-how-to-choose-heartfelt-gifts',
    excerpt: '送礼是一门学问，一份好礼物不在于价格，而在于用心。久久精品为你整理了不同场合的送礼指南，让每一份礼物都送到心坎里。',
    content: `<p>送礼是人与人之间最温暖的情感表达。但如何在琳琅满目的选择中，找到那份恰到好处的礼物？久久精品认为，好的礼物有三个标准：实用、有品质、有故事。</p>
    <h2>送给闺蜜的暖心之选</h2>
    <p>真丝枕套套装是绝佳的闺蜜礼物。它不仅实用，而且代表的是一份"希望你每晚都好眠"的温柔心意。22姆米重磅真丝的质感，让收到的人感受到满满的被珍视。</p>
    <h2>送给长辈的敬意之选</h2>
    <p>日本手工铸铁茶壶是送给爱茶长辈的不二之选。它不仅是一件实用茶具，更承载着传统工艺的温度。每次泡茶，都是一次与匠人精神的对话。</p>
    <h2>送给爱书之人的雅致之选</h2>
    <p>复古黄铜书签礼盒，四枚不同纹样的精致书签，每一枚都是一个小小的艺术品。送给爱阅读的朋友，为他们的阅读时光增添一份仪式感。</p>
    <h2>送给自己的一份犒赏</h2>
    <p>别忘了，最好的礼物有时是送给自己的。一只意大利手工牛皮托特包，或是一条日式纯银锁骨链，都是对自己努力生活的最好肯定。</p>
    <p>久久精品，为你的每一份心意找到最合适的表达。</p>`,
    category: '生活优选',
    author: '久久编辑部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautifully%20wrapped%20gift%20boxes%20with%20elegant%20ribbons%20on%20a%20wooden%20table%2C%20surrounded%20by%20dried%20flowers%20and%20warm%20candlelight%2C%20luxury%20gift%20giving%20aesthetic%2C%20thoughtful%20presentation&width=1200&height=600&seq=article-a004&orientation=landscape',
    imageWidth: 1200,
    imageHeight: 600,
    imageSeq: 'article-a004',
    imageQuery: 'Beautifully wrapped gift boxes with elegant ribbons on a wooden table, surrounded by dried flowers and warm candlelight, luxury gift giving aesthetic, thoughtful presentation',
    readTime: 5,
    publishedAt: '2026-07-10',
    tags: ['送礼', '礼物推荐', '心意', '节日'],
  },
  {
    id: 'a005',
    title: '从选材到工艺：一件好物是如何诞生的？',
    slug: 'from-material-to-craftsmanship-how-quality-products-are-made',
    excerpt: '每一件久久精品推荐的好物背后，都有着不为人知的匠心故事。今天，我们带你走进幕后，了解从原材料挑选到成品诞生的全过程。',
    content: `<p>在久久精品，我们对"好物"有着极为严苛的标准。一件商品要进入我们的推荐列表，需要经过选材、工艺、设计、体验四大环节的层层筛选。</p>
    <h2>第一步：源头选材</h2>
    <p>好材料是好产品的基础。我们的买手团队深入全球产地，从意大利托斯卡纳的牛皮到中国内蒙古的羊绒，从日本南部的铁矿石到北欧的百年白橡木林——只为找到最优质的原材料。</p>
    <h2>第二步：工艺审核</h2>
    <p>有了好材料，还需要好工艺来成就。我们考察每一个合作工坊的制作流程，确保每一道工序都达到久久精品的品质标准。那些拥有数十年经验的老匠人，是我们最为珍视的合作伙伴。</p>
    <h2>第三步：设计美学</h2>
    <p>在久久精品看来，好设计是形式与功能的完美统一。我们偏爱简约而不简单的设计——去掉一切多余的装饰，让材质和工艺本身说话。这种"少即是多"的美学理念，贯穿于我们推荐的每一件商品。</p>
    <h2>第四步：真实体验</h2>
    <p>最后，每一件商品都要经过真实用户的体验测试。只有那些在日常使用中真正让人感到愉悦、方便、舒适的产品，才能最终出现在久久精品的推荐清单中。</p>
    <p>品质，从来不是一蹴而就的。久久精品，用心为你甄选每一件好物。</p>`,
    category: '家居好物',
    author: '久久编辑部',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20craftsman%20working%20meticulously%20in%20a%20warm%20lit%20workshop%2C%20hands%20carefully%20shaping%20leather%20or%20wood%2C%20traditional%20craftsmanship%2C%20tools%20on%20a%20wooden%20workbench%2C%20authentic%20artisan%20atmosphere&width=1200&height=600&seq=article-a005&orientation=landscape',
    imageWidth: 1200,
    imageHeight: 600,
    imageSeq: 'article-a005',
    imageQuery: 'A craftsman working meticulously in a warm lit workshop, hands carefully shaping leather or wood, traditional craftsmanship, tools on a wooden workbench, authentic artisan atmosphere',
    readTime: 6,
    publishedAt: '2026-06-28',
    tags: ['工艺', '匠心', '品质', '选材'],
  },
  {
    id: 'a006',
    title: '新手瑜伽指南：从一张好瑜伽垫开始你的身心之旅',
    slug: 'beginner-yoga-guide-starting-with-a-good-mat',
    excerpt: '瑜伽不需要昂贵的装备或完美的身体条件。你需要的，只是一张好瑜伽垫和一颗愿意开始的心。久久精品为你准备了一份新手友好指南。',
    content: `<p>越来越多的人开始意识到身心健康的重要性，而瑜伽作为一种古老而有效的身心练习方式，正受到越来越多人的喜爱。如果你也想开始，这篇指南就是为你准备的。</p>
    <h2>为什么要从一张好瑜伽垫开始？</h2>
    <p>瑜伽垫是你练习时最亲密的伙伴。一张好的瑜伽垫能提供足够的缓冲和防滑保护，让你在练习中更专注、更安全。天然软木材质的瑜伽垫不仅环保，而且越用越有质感。</p>
    <h2>零基础也能开始的5个简单体式</h2>
    <p>不需要一上来就挑战高难度。从山式、猫牛式、下犬式、婴儿式和仰卧扭转式开始，每天只需15分钟，坚持一周你就能感受到身体的变化。</p>
    <h2>居家练习的小贴士</h2>
    <p>找一个安静的角落，铺开瑜伽垫，点上一支香薰蜡烛，放一段舒缓的音乐——这就是你的私人瑜伽空间。舒适的有机棉麻家居服，能让你的练习体验再上一个台阶。</p>
    <h2>坚持的秘诀</h2>
    <p>不要把瑜伽当成任务，而是把它当作与自己身体对话的时间。不追求完美，只追求坚持。每一天的微小进步，都会在未来汇聚成巨大的改变。</p>
    <p>久久精品相信，照顾好自己，是一切美好生活的起点。</p>`,
    category: '生活优选',
    author: '久久编辑部',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20serene%20home%20yoga%20practice%20space%20with%20a%20natural%20cork%20yoga%20mat%2C%20morning%20sunlight%20streaming%20through%20windows%2C%20indoor%20plants%2C%20minimalist%20and%20peaceful%20atmosphere%2C%20wellness%20lifestyle%20photography&width=1200&height=600&seq=article-a006&orientation=landscape',
    imageWidth: 1200,
    imageHeight: 600,
    imageSeq: 'article-a006',
    imageQuery: 'A serene home yoga practice space with a natural cork yoga mat, morning sunlight streaming through windows, indoor plants, minimalist and peaceful atmosphere, wellness lifestyle photography',
    readTime: 5,
    publishedAt: '2026-06-15',
    tags: ['瑜伽', '健康', '运动', '入门指南'],
  },
];